// logo image
import logo from "../Images/logo.png";
// bootstrap components
import { Row, Col } from "react-bootstrap";

// The Header component takes get props from the App component ive deconstructed the values so i can omit using the props value
function Header({ name, loggedIn }) {
  return (
    <header className="header">
      <div className="wrapper">
        <Row className="mx-0">
          <Col>
            {/* using logo image */}
            <img className="img-fluid logo" src={logo} alt="" />
            <h1 className="main-heading">
              Delicious <span>food</span>
            </h1>
            <h2 className="sub-heading">
              XYZ is a luxury fast food restaurant based in Johannesburg.
            </h2>
            <div className="greeting">
              {/* using props */}
              {loggedIn ? `Welcome back, ${name}` : "Please log in"}
            </div>
          </Col>
        </Row>
      </div>
    </header>
  );
}

export default Header;
